import React, { useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Alert, Box, Card, Link, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Typography } from '@mui/material';

import { protokollListe } from '../api';
import { Seitenkopf } from '../komponenten/Bausteine';
import { fehlertext, zeitpunkt } from '../utils/format';

export default function Protokoll() {
  const navigate = useNavigate();
  const [liste, setListe] = useState(null);
  const [fehler, setFehler] = useState('');
  const [suche, setSuche] = useState('');

  useEffect(() => {
    protokollListe().then((r) => setListe(r.data)).catch((e) => setFehler(fehlertext(e, 'Protokoll konnte nicht geladen werden.')));
  }, []);

  const sichtbar = useMemo(() => {
    const worte = suche.toLowerCase().split(/\s+/).filter(Boolean);
    return (liste || []).filter((p) => {
      const heu = [p.kunde_name, p.benutzer, p.text].filter(Boolean).join(' ').toLowerCase();
      return worte.every((w) => heu.includes(w));
    });
  }, [liste, suche]);

  return (
    <Box>
      <Seitenkopf titel="Protokoll" untertitel="Jede Änderung im Portal: wer, wann, was. Einträge bleiben stehen, auch wenn Kunde oder Lizenz gelöscht werden." />
      {fehler && <Alert severity="error" sx={{ mb: 2 }}>{fehler}</Alert>}
      <TextField
        id="protokoll-suche" placeholder="Kunde, Benutzer oder Text suchen" value={suche} fullWidth
        onChange={(e) => setSuche(e.target.value)} sx={{ mb: 2, bgcolor: 'background.paper' }}
      />
      <Card>
        <TableContainer>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>Zeitpunkt</TableCell>
                <TableCell>Kunde</TableCell>
                <TableCell>Was</TableCell>
                <TableCell>Wer</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {sichtbar.map((p) => (
                <TableRow key={p.id}>
                  <TableCell sx={{ whiteSpace: 'nowrap', fontVariantNumeric: 'tabular-nums' }}>{zeitpunkt(p.zeitpunkt)}</TableCell>
                  <TableCell>
                    {p.kunde_id
                      ? <Link component="button" underline="hover" color="inherit" onClick={() => navigate(`/kunden/${p.kunde_id}`)} sx={{ textAlign: 'left', fontWeight: 600 }}>{p.kunde_name}</Link>
                      : (p.kunde_name || '–')}
                  </TableCell>
                  <TableCell sx={{ overflowWrap: 'anywhere' }}>{p.text}</TableCell>
                  <TableCell sx={{ whiteSpace: 'nowrap' }}>{p.benutzer || <Typography component="span" variant="body2" color="text.secondary">Kunde / System</Typography>}</TableCell>
                </TableRow>
              ))}
              {liste && sichtbar.length === 0 && (
                <TableRow>
                  <TableCell colSpan={4} sx={{ textAlign: 'center', py: 5, color: 'text.secondary' }}>
                    {liste.length === 0 ? 'Noch keine Einträge. Protokolliert wird ab dem Neuaufbau des Portals.' : 'Kein Eintrag passt zur Suche.'}
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Card>
    </Box>
  );
}
